import { createFileRoute, redirect } from '@tanstack/react-router';

import { PERMISSIONS as P, projectPermissions } from '@/app/permissions';
import { bootSession } from '@/lib/auth/session';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/')({
  beforeLoad: async ({ params }) => {
    // Whoever asks for or decides on materials starts at requisitions; the
    // site receiver at deliveries; the owner side (read-only) at orders.
    const { me } = await bootSession();
    const granted = projectPermissions(me, params.projectId);
    const to = [P.procurementRequest, P.procurementManage, P.procurementApprove].some((p) =>
      granted.has(p),
    )
      ? '/projects/$projectId/procurement/requisitions'
      : granted.has(P.deliveriesReceive)
        ? '/projects/$projectId/procurement/deliveries'
        : '/projects/$projectId/procurement/orders';
    throw redirect({ to, params, replace: true });
  },
});
